import { Utilities } from "../../../utils/utilities";
import { FirebaseData } from "../General/FirebaseData";

export class UserDeviceData extends FirebaseData {
  platform: string = "";
  model: string = "";
  osVersion: string = "";
  lastLogin?: Date;
  browser: string = "";

  setup(data: any) {
    this.platform = typeof data.platform === "string" ? data.platform : "";
    this.model = typeof data.model === "string" ? data.model : "";
    this.osVersion = typeof data.osVersion === "string" ? data.osVersion : "";
    this.browser = typeof data.browser === "string" ? data.browser : "";
    this.lastLogin = Utilities.getDateFromTimestamp(data.lastLogin);

    super.setup(data);
  }
}

